import InputWrapper from '../InputWrapper';

interface Props {
  children?: React.ReactNode,
  name: string,
  type: string,
  label: string,
  value: string,
  maxLength?: number,
  pattern?: string,
  onChange(e: any): void,
  required?: boolean,
  disabled?: boolean
}

export const Input = ({children, name, type, label, value, maxLength, pattern, onChange, required, disabled}: Props) => {

  let onFocus = ""

  if (type==="datetime-local") {
    onFocus = type
    type = "text"
  }

  return (
    <InputWrapper label={label}>
      <input
        name={name}
        id={name}
        type={type}
        placeholder={label}
        value={value}
        maxLength={maxLength}
        pattern={pattern}
        onChange={e => onChange(e)}
        required={required}
        disabled={disabled}
        onFocus={onFocus ? ((e) => {e.target.type=onFocus}):(undefined)}
      />
      {children}
    </InputWrapper>
  )
}

export default Input;
